import React from 'react';
import { styled } from '@abyss/web/tools/styled';
import { FooterCopyRights } from "./FooterCopyRights";

const FooterWrapper = styled('div', {
    backgroundColor: '$primary1',
    width: '100%',
    padding: '8px 24px',
    margin: '0',
    position: 'relative',
    zIndex: 1201,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

export const Footer = () => {
    return (
        <FooterWrapper>
            <FooterCopyRights />
        </FooterWrapper>
    );
}